var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",style:(_vm.wrapStyle)},[_c('div',[_c('van-icon',{attrs:{"name":"info","size":"40","color":"#979797"}})],1),_c('p',[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }